module.exports = __webpack_public_path__ + "img/air_open.622f3d8d.png";